/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_myteam_results_title = /** @type {(inputs: { race: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your ${i?.race} result`)
};

const es_f1_myteam_results_title = /** @type {(inputs: { race: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu resultado en ${i?.race}`)
};

const de_f1_myteam_results_title = /** @type {(inputs: { race: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dein Ergebnis: ${i?.race}`)
};

const nl_f1_myteam_results_title = /** @type {(inputs: { race: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jouw resultaat: ${i?.race}`)
};

const fr_f1_myteam_results_title = /** @type {(inputs: { race: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Votre résultat : ${i?.race}`)
};

const it_f1_myteam_results_title = /** @type {(inputs: { race: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il tuo risultato: ${i?.race}`)
};

const pt_br2_f1_myteam_results_title = /** @type {(inputs: { race: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seu resultado em ${i?.race}`)
};

const pt_f1_myteam_results_title = /** @type {(inputs: { race: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O teu resultado em ${i?.race}`)
};

const ja_f1_myteam_results_title = /** @type {(inputs: { race: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.race}の結果`)
};

const zh_f1_myteam_results_title = /** @type {(inputs: { race: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你的${i?.race}战绩`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ race: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_myteam_results_title = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_myteam_results_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_myteam_results_title", locale)
	if (locale === "en") return en_f1_myteam_results_title(inputs)
	if (locale === "es") return es_f1_myteam_results_title(inputs)
	if (locale === "de") return de_f1_myteam_results_title(inputs)
	if (locale === "nl") return nl_f1_myteam_results_title(inputs)
	if (locale === "fr") return fr_f1_myteam_results_title(inputs)
	if (locale === "it") return it_f1_myteam_results_title(inputs)
	if (locale === "pt-BR") return pt_br2_f1_myteam_results_title(inputs)
	if (locale === "pt") return pt_f1_myteam_results_title(inputs)
	if (locale === "ja") return ja_f1_myteam_results_title(inputs)
	return zh_f1_myteam_results_title(inputs)
};